<template>
  <section id="company_container" class="custom-container">
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    <AssingPermisses ref="refAssingPermisses" @updatedDevice="updatedDevice"/>
    <div class="columns v-align-center">
      <div class="column is-3">
        <CompanySelector v-model="company"/>
      </div>
      <div class="column input-search-content mt-button2">
        <b-field class="input-search">
          <b-input
              placeholder="Buscar"
              type="text"
              name="search"
              v-model="search"
              icon-right="magnify"
          >
          </b-input>
        </b-field>
        <b-field class="pagination-select">
          <b-select
              placeholder="Páginas"
              expanded
              v-model="pagination"
              name="pagination"
          >
            <option
                v-for="option in paginationList"
                :value="option.id"
                :key="option.id"
                :id="option.id"
            >
              {{ option.label }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column text-right mt-button2">
        <vs-button
            color="primary"
            icon="add"
            class="btn-add-device"
            @click="openModal"
        >Asignar Permisos
        </vs-button
        >
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-table :data="pagedDevices">
          <b-table-column field="code" label="Id" v-slot="props">
            <text-highlight :queries="search">
              {{ props.row.code }}
            </text-highlight>
          </b-table-column>
          <b-table-column field="company.code" label="Empresa" v-slot="props">
            <text-highlight :queries="search">
              {{ props.row.company ? props.row.company.name : "—" }}
            </text-highlight>
          </b-table-column>
          <b-table-column
              field="numUsers"
              label="Cantidad de usuarios"
              v-slot="props"
          >
            <text-highlight :queries="search">
              {{ displayCount(props.row.numUsers) }}
            </text-highlight>
          </b-table-column>
          <b-table-column
              field="numModules"
              label="Cantidad de módulos"
              v-slot="props"
          >
            <text-highlight :queries="search">
              {{ displayCount(props.row.numModules) }}
            </text-highlight>
          </b-table-column>
          <b-table-column field="status" label="Estado" v-slot="props">
            <text-highlight :queries="search">
              {{ parseStatus(props.row.status) }}
            </text-highlight>
          </b-table-column>
          <b-table-column field="title" label="Nombre terminal" v-slot="props">
            <div class="flex name-options-table">
              <span class="label-title">
                <text-highlight :queries="search">
                  {{ props.row.title }}
                </text-highlight>
              </span>
              <div class="options flex">
                <button
                    title="Gestionar permisos"
                    class="btn primary edit"
                    v-on:click="editRow(props.row)"
                >
                  <span class="material-icons"> settings </span>
                </button>
              </div>
            </div>
          </b-table-column>
          <template #empty>
            <div class="has-text-centered">Sin registros</div>
          </template>
        </b-table>
      </div>
    </div>
    <div class="columns">
      <div class="column" v-if="showPagination">
        <vs-pagination
            :max="5"
            :total="totalPages"
            v-model="page"
            prev-icon="arrow_back"
            next-icon="arrow_forward"
        ></vs-pagination>
      </div>
    </div>
  </section>
</template>

<script>
import {DETAILS_STATUS} from "@/global/constants";
import {configToast, TOAST_TYPES} from "@/global/toast";
import AssingPermisses from "./AssingPermisses.vue";
import CompanySelector from "@/components/Shared/CompanySelector";
import deviceEndpoint from "@/endpoints/machine/DeviceEndpoint";

export default {
  components: {AssingPermisses, CompanySelector},
  data: () => ({
    company: null,
    isLoading: false,
    allDevices: [],
    search: "",
    page: 1,
    pagination: 10,
    paginationList: [
      {id: 10, label: "10"},
      {id: 30, label: "30"},
      {id: 60, label: "60"},
      {id: 100, label: "100"},
      {id: 1000, label: "1000"},
    ],
  }),
  computed: {
    filteredDevices() {
      const term = this.normalize(this.search);
      if (!term) {
        return this.allDevices;
      }
      return this.allDevices.filter((row) =>
          this.normalize(this.rowSearchText(row)).includes(term)
      );
    },
    totalPages() {
      return Math.ceil(this.filteredDevices.length / this.pagination);
    },
    showPagination() {
      return this.filteredDevices.length > this.pagination;
    },
    pagedDevices() {
      if (!this.showPagination) {
        return this.filteredDevices;
      }
      const start = (this.page - 1) * this.pagination;
      return this.filteredDevices.slice(start, start + this.pagination);
    },
  },
  watch: {
    company() {
      this.page = 1;
      this.getListDevices();
    },
    search() {
      this.page = 1;
    },
    pagination() {
      this.page = 1;
    },
  },
  mounted() {
    this.getListDevices();
  },
  methods: {
    normalize(value) {
      const str = value === null || value === undefined ? "" : String(value);
      return str
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .trim();
    },
    rowSearchText(row) {
      const company = row.company ? row.company.name : "";
      return [
        row.code,
        company,
        this.displayCount(row.numUsers),
        this.displayCount(row.numModules),
        this.parseStatus(row.status),
        row.title,
      ].join(" ");
    },
    displayCount(value) {
      return value === null || value === undefined ? "N/D" : value;
    },
    parseStatus(status) {
      return DETAILS_STATUS[status]
          ? DETAILS_STATUS[status].description
          : "N/A";
    },
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#company_container");
      return instance.open(message, type);
    },
    updatedDevice() {
      this.getListDevices();
    },
    editRow(row) {
      if (!row.company) {
        this.toast(
            "La terminal no tiene empresa asignada",
            TOAST_TYPES.WARNING
        );
        return;
      }
      this.$refs.refAssingPermisses.setData({
        deviceId: row.code,
        company: row.company.code,
      });
      this.openModal();
    },
    openModal() {
      this.$refs.refAssingPermisses.openModal();
    },
    getListDevices() {
      this.isLoading = true;
      deviceEndpoint
          .getDevicesPermissionsList(this.company || undefined)
          .then((info) => {
            this.allDevices = Array.isArray(info) ? info : [];
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
  },
};
</script>

<style>
.sub-title {
  font-size: 1.6em;
  margin: 0;
  padding: 0;
}

.custom-container {
  margin-top: 20px;
}

.input-search {
  max-width: 300px;
}

.btn-add-device {
  margin-left: auto;
}

.text-right {
  display: flex;
  justify-content: flex-end;
}

.name-options-table {
  display: flex;
  width: 100%;
}

.name-options-table .options {
  margin-left: auto;
}

.name-options-table .options .btn {
  width: 30px;
  height: 30px;
  border-radius: 5px;
  background-color: #efefef;
  display: flex;
  padding: 0;
  outline: none;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  transition: all 1ms ease;
}

.name-options-table .options .btn span {
  font-size: 1.5em;
}

.name-options-table .options .btn:last-child {
  margin-right: 0;
}

.name-options-table .options .btn.primary {
  background-color: #1d76fb;
  color: #ffffff;
}

.name-options-table .options .btn:active {
  background-color: black;
  color: #ffffff;
}

.pagination-select {
  max-width: 120px;
}

.input-search-content {
  display: flex;
}
</style>
